export interface CreateOfferRequest {
  lead: LeadInfo;
  offerDetails: RequestInfo;
}

export interface LeadInfo {
  firstname: string;
  lastname: string;
  address: string;
  city: string;
  district?: string;
  region?: string;
  country: string;
  phoneNumber: string;
  email: string;
}

export interface RequestInfo {
  dentalArch: string;
  treatmentType: string;
  requestDetails: string;
  requestMotivation: RequestMotivationEnum;
  districtId?: string;
  countryId: string;
  regionId?: string;
}

export enum RequestLabelEnum {
  NEW = "NEW",
  CONTACTED = "CONTACTED",
  IN_PROGRESS = "IN_PROGRESS",
  CLOSED = "CLOSED"
}

export enum RequestMotivationEnum {
  DENTAL_CARE = "DENTAL_CARE",
  DENTAL_IMPLANTS = "DENTAL_IMPLANTS",
  SMILE_AESTHETICS = "SMILE_AESTHETICS",
  ARCHIVED = "Archived",
}

export const RequestMotivationLabels: Record<RequestMotivationEnum, string> = {
  [RequestMotivationEnum.DENTAL_CARE]: "Dental Care",
  [RequestMotivationEnum.DENTAL_IMPLANTS]: "Dental Implants",
  [RequestMotivationEnum.SMILE_AESTHETICS]: "Smile Aesthetics",
  [RequestMotivationEnum.ARCHIVED]: "Archived",
};